import React from "react";

export default function UserGroupPeople() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="44"
        height="44"
        rx="12"
        fill="url(#paint0_linear_872_145)"
        fillOpacity="0.08"
      />
      <g opacity="0.32">
        <path
          d="M18.25 21.1667C19.4006 21.1667 20.3333 20.2339 20.3333 19.0833C20.3333 17.9327 19.4006 17 18.25 17C17.0994 17 16.1666 17.9327 16.1666 19.0833C16.1666 20.2339 17.0994 21.1667 18.25 21.1667Z"
          fill="url(#paint1_linear_872_145)"
        />
        <path
          d="M25.75 21.1667C26.9006 21.1667 27.8333 20.2339 27.8333 19.0833C27.8333 17.9327 26.9006 17 25.75 17C24.5994 17 23.6666 17.9327 23.6666 19.0833C23.6666 20.2339 24.5994 21.1667 25.75 21.1667Z"
          fill="url(#paint2_linear_872_145)"
        />
        <path
          d="M27 25.3333C27 26.714 24.7614 27.8333 22 27.8333C19.2385 27.8333 17 26.714 17 25.3333C17 23.9526 19.2385 22.8333 22 22.8333C24.7614 22.8333 27 23.9526 27 25.3333Z"
          fill="url(#paint3_linear_872_145)"
        />
      </g>
      <path
        d="M24.5 18.6667C24.5 20.0474 23.3807 21.1667 22 21.1667C20.6192 21.1667 19.5 20.0474 19.5 18.6667C19.5 17.286 20.6192 16.1667 22 16.1667C23.3807 16.1667 24.5 17.286 24.5 18.6667Z"
        fill="url(#paint4_linear_872_145)"
      />
      <path
        d="M26.9999 25.3333C26.9999 25.9686 26.526 26.5485 25.7455 26.9895C25.884 26.9964 26.0245 27 26.1665 27C28.4678 27 30.3332 26.0673 30.3332 24.9167C30.3332 23.7661 28.4678 22.8333 26.1665 22.8333C25.4489 22.8333 24.7735 22.9241 24.184 23.0838C25.851 23.4893 26.9999 24.3442 26.9999 25.3333Z"
        fill="url(#paint5_linear_872_145)"
      />
      <path
        d="M17.8333 27C17.9754 27 18.1159 26.9964 18.2544 26.9895C17.4738 26.5485 17 25.9686 17 25.3333C17 24.3442 18.1489 23.4893 19.8159 23.0838C19.2263 22.9241 18.551 22.8333 17.8333 22.8333C15.5321 22.8333 13.6666 23.7661 13.6666 24.9167C13.6666 26.0673 15.5321 27 17.8333 27Z"
        fill="url(#paint6_linear_872_145)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_872_145"
          x1="21.9624"
          y1="-2.94196"
          x2="21.9624"
          y2="45.3794"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_872_145"
          x1="21.99"
          y1="16.2757"
          x2="21.99"
          y2="28.173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_872_145"
          x1="21.99"
          y1="16.2757"
          x2="21.99"
          y2="28.173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_872_145"
          x1="21.99"
          y1="16.2757"
          x2="21.99"
          y2="28.173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_872_145"
          x1="21.9857"
          y1="15.4423"
          x2="21.9857"
          y2="27.3396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_872_145"
          x1="21.9857"
          y1="15.4423"
          x2="21.9857"
          y2="27.3396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_872_145"
          x1="21.9857"
          y1="15.4423"
          x2="21.9857"
          y2="27.3396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
      </defs>
    </svg>
  );
}
